import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authApi } from "../api/authApi";
import Message from "../components/Message";

export default function Signup() {
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirm_password: "",
  });
  const [notice, setNotice] = useState(null);
  const navigate = useNavigate();

  function updateField(event) {
    setForm((current) => ({ ...current, [event.target.name]: event.target.value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();

    if (form.password !== form.confirm_password) {
      setNotice({ type: "error", text: "Passwords do not match." });
      return;
    }

    try {
      await authApi.signup(form);
      navigate("/login?role=customer");
    } catch (error) {
      setNotice({ type: "error", text: error.message });
    }
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1>Create Your Account</h1>
        <Message notice={notice} />

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="first_name">First Name</label>
            <input type="text" id="first_name" name="first_name" required className="form-control" value={form.first_name} onChange={updateField} />
          </div>

          <div className="form-group">
            <label htmlFor="last_name">Last Name</label>
            <input type="text" id="last_name" name="last_name" required className="form-control" value={form.last_name} onChange={updateField} />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input type="email" id="email" name="email" required className="form-control" value={form.email} onChange={updateField} />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input type="password" id="password" name="password" required className="form-control" value={form.password} onChange={updateField} />
            <small className="password-help">Minimum 8 characters, must contain uppercase letter and number</small>
          </div>

          <div className="form-group">
            <label htmlFor="confirm_password">Confirm Password</label>
            <input type="password" id="confirm_password" name="confirm_password" required className="form-control" value={form.confirm_password} onChange={updateField} />
          </div>

          <button type="submit" className="btn btn-primary btn-block">Create Account</button>
        </form>

        <p className="auth-link">
          Already have an account? <Link to="/login?role=customer">Login here</Link>
        </p>
      </div>
    </div>
  );
}
